import { render, staticRenderFns } from "./ruralvitalization.vue?vue&type=template&id=7b8cc2e3&scoped=true"
import script from "./ruralvitalization.vue?vue&type=script&lang=js"
export * from "./ruralvitalization.vue?vue&type=script&lang=js"
import style0 from "./ruralvitalization.vue?vue&type=style&index=0&id=7b8cc2e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cc2e3",
  null
  
)

export default component.exports